import type { ReactNode } from 'react';

export interface TopBarProps {
  title: ReactNode;
  /** 제목 아래 보조 설명 */
  subtitle?: ReactNode;
  /** 우측 액션 영역 (버튼 등) */
  actions?: ReactNode;
}

/** 페이지 상단바 (제목 + 액션) */
export default function TopBar({ title, subtitle, actions }: TopBarProps) {
  return (
    <header className="topbar">
      <div>
        <h1 className="topbar__title">{title}</h1>
        {subtitle && <div className="topbar__sub">{subtitle}</div>}
      </div>
      {actions && <div className="topbar__actions">{actions}</div>}
    </header>
  );
}
